export enum SupportSettingsChatType {
    Zendesk = 'Zendesk',
    Cognigy = 'Cognigy'
}
